import { render, staticRenderFns } from "./KAMIncidentOverview.vue?vue&type=template&id=6b49f790&scoped=true"
import script from "./KAMIncidentOverview.vue?vue&type=script&lang=ts"
export * from "./KAMIncidentOverview.vue?vue&type=script&lang=ts"
import style0 from "./KAMIncidentOverview.vue?vue&type=style&index=0&id=6b49f790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b49f790",
  null
  
)

export default component.exports